import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=357907dc&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357907dc')) {
      api.createRecord('357907dc', component.options)
    } else {
      api.reload('357907dc', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=357907dc&", function () {
      api.rerender('357907dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4bHD2y2JfW43P/JS/comp/stardisplay.vue"
export default component.exports